import { queryOptions, useQuery } from '@tanstack/react-query';

import { ApiResponse, QueryRefetchInterval } from '@cast/shared-types';

import { apiClient } from '@cast/infrastructure-api';

const REPORTING_CAPABILITIES_QUERY_KEY = 'reporting-capabilities';

const apiFn = apiClient.costReport.getReportCapabilities;
type ReportCapabilitiesResponse = ApiResponse<typeof apiFn>;

type ReportCapabilitiesQueryArgs = {
  clusterId: string;
  startTime: string;
  endTime: string;
  enabled?: boolean;
  refetchInterval?: QueryRefetchInterval<ReportCapabilitiesResponse>;
};

const getReportCapabilitiesQueryKey = (
  startTime: string,
  endTime: string,
  clusterId: string
) => [REPORTING_CAPABILITIES_QUERY_KEY, startTime, endTime, clusterId] as const;

const getReportCapabilitiesQueryOptions = ({
  clusterId,
  startTime,
  endTime,
  enabled,
  refetchInterval,
}: ReportCapabilitiesQueryArgs) =>
  queryOptions({
    queryKey: getReportCapabilitiesQueryKey(startTime, endTime, clusterId),
    queryFn: async () => {
      const { data } = await apiFn({
        clusterId,
        startTime,
        endTime,
      });

      return data;
    },
    enabled,
    refetchInterval,
  });

export const useReportCapabilitiesQuery = (
  args: ReportCapabilitiesQueryArgs
) => {
  return useQuery(getReportCapabilitiesQueryOptions(args));
};
